/**
 * enrollmentAdminBuilder — slice administrativo de enrollment:
 * Período Letivo (ano/semestre + vigência) e Calendário Acadêmico (eventos).
 *
 * @since fase FE cobertura-total (B2-1/B2-2 do backend)
 */
import type { $Fetch } from 'ofetch';

import { HttpPeriodoLetivoGateway } from '@/infrastructure/http/HttpPeriodoLetivoGateway';
import { HttpCalendarioEventoGateway } from '@/infrastructure/http/HttpCalendarioEventoGateway';

import {
  ListPeriodosLetivos, CreatePeriodoLetivo, UpdatePeriodoLetivo,
  MarcarVigentePeriodo, EncerrarPeriodo,
} from '@/application/usecase/PeriodoLetivoUseCaseImpl';
import {
  ListCalendarioEventos, CreateCalendarioEvento, UpdateCalendarioEvento, DeleteCalendarioEvento,
} from '@/application/usecase/CalendarioEventoUseCaseImpl';

export function buildEnrollmentAdminSlice(httpClient: $Fetch) {
  const periodoGateway = new HttpPeriodoLetivoGateway(httpClient);
  const calendarioGateway = new HttpCalendarioEventoGateway(httpClient);

  const useCases = {
    listPeriodosLetivos: new ListPeriodosLetivos(periodoGateway),
    createPeriodoLetivo: new CreatePeriodoLetivo(periodoGateway),
    updatePeriodoLetivo: new UpdatePeriodoLetivo(periodoGateway),
    marcarVigentePeriodo: new MarcarVigentePeriodo(periodoGateway),
    encerrarPeriodo: new EncerrarPeriodo(periodoGateway),
    listCalendarioEventos: new ListCalendarioEventos(calendarioGateway),
    createCalendarioEvento: new CreateCalendarioEvento(calendarioGateway),
    updateCalendarioEvento: new UpdateCalendarioEvento(calendarioGateway),
    deleteCalendarioEvento: new DeleteCalendarioEvento(calendarioGateway),
  };

  return { useCases };
}
